import React from "react";
import ProgramTemplate from "@/components/ProgramTemplate";
import { PROGRAM_FOZ_78 } from "@/lib/programs/fezSidialiOuarzazate78";

export default function FezSidialiOuarzazate78Page() {
  return <ProgramTemplate program={PROGRAM_FOZ_78} variant="foz" showJourneyChronology />;
}
